import React from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { changePasswordAPI } from "../service/AuthService";
import { Encrypt } from "../utils/constants";

export default function MyProfile() {
  const userData = useSelector((state) => state.account.userData);
  const [oldPassword, setOldPassword] = React.useState("");
  const dispatch = useDispatch();
  const [password, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const handleChangePassword = async () => {
    if (password === "" || confirmPassword === "" || oldPassword === "") {
      toast.error("Please fill all the fields");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Password and confirm password does not match");
      return;
    }
    if (password === oldPassword) {
      toast.error("New password and old password cannot be same");
      return;
    }

    var { data, code, message, response, error } = await changePasswordAPI(
      {
        newPassword: Encrypt(password),
        password: Encrypt(oldPassword),
        resetRequired: false,
        uid: userData.id,
      },
      userData.token
    );
    if (code === 200) {
      toast.success("Password changed successfully");
      dispatch({
        type: "accountData/logOut",
        payload: {},
      });
      dispatch({
        type: "gameData/logOut",
        payload: {},
      });
    } else {
      toast.error("Wrong password");
    }
  };

  return (
    <app-my-profile _nghost-ng-c3807070604="" className="ng-star-inserted">
      <div _ngcontent-ng-c3807070604="" className="cardMain">
        <div _ngcontent-ng-c3807070604="" className="row">
          <div
            _ngcontent-ng-c3807070604=""
            className="col-sm-12 col-md-12 p-mobile-1"
          >
            <div
              _ngcontent-ng-c3807070604=""
              className="card card-accent-primary"
            >
              <div
                _ngcontent-ng-c3807070604=""
                className="card-header account-detail-head"
              >
                <span _ngcontent-ng-c3807070604="" className="acc-dtl">
                  Account Details
                </span>
              </div>
              <div
                _ngcontent-ng-c3807070604=""
                className="card-body account-detail-body"
              >
                <div _ngcontent-ng-c3807070604="" className="bd-example">
                  <dl _ngcontent-ng-c3807070604="" className="row">
                    <dt _ngcontent-ng-c3807070604="" className="col-sm-3">
                      Name
                    </dt>
                    <dd _ngcontent-ng-c3807070604="" className="col-sm-9">
                      {userData?.username}
                    </dd>
                    <dt _ngcontent-ng-c3807070604="" className="col-sm-3">
                      Commission
                    </dt>
                    <dd _ngcontent-ng-c3807070604="" className="col-sm-9">
                      {" "}
                      0{" "}
                    </dd>
                    <dt _ngcontent-ng-c3807070604="" className="col-sm-3">
                      Rolling Commission
                    </dt>
                    <dd _ngcontent-ng-c3807070604="" className="col-sm-9">
                      <a
                        _ngcontent-ng-c3807070604=""
                        data-bs-toggle="modal"
                        data-bs-target="#rollingModal"
                      >
                        <i _ngcontent-ng-c3807070604="" className="fa fa-eye" />
                      </a>
                    </dd>
                    <dt _ngcontent-ng-c3807070604="" className="col-sm-3">
                      Exposure Limit
                    </dt>
                    <dd _ngcontent-ng-c3807070604="" className="col-sm-9">
                      {" "}
                      {userData?.exposureLimit}{" "}
                    </dd>
                    <dt _ngcontent-ng-c3807070604="" className="col-sm-3">
                      Password
                    </dt>
                    <dd _ngcontent-ng-c3807070604="" className="col-sm-9">
                      <span _ngcontent-ng-c3807070604="" className="me-3">
                        *********
                      </span>
                      <a
                        _ngcontent-ng-c3807070604=""
                        data-bs-toggle="modal"
                        data-bs-target="#changePasswordModal"
                        className="edit-password"
                      >
                        {" "}
                        Edit{" "}
                        <i
                          _ngcontent-ng-c3807070604=""
                          className="fa fa-pencil-square-o fa-lg"
                        />
                      </a>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        _ngcontent-ng-c3807070604=""
        id="rollingModal"
        tabIndex={-1}
        aria-labelledby="rollingModalLabal"
        aria-hidden="true"
        className="modal fade"
      >
        <div _ngcontent-ng-c3807070604="" className="modal-dialog">
          <div _ngcontent-ng-c3807070604="" className="modal-content">
            <div
              _ngcontent-ng-c3807070604=""
              className="modal-header account-detail-head"
            >
              <h5 _ngcontent-ng-c3807070604="" className="modal-title">
                Rolling Commission
              </h5>
              <button
                _ngcontent-ng-c3807070604=""
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                className="close"
              >
                <span _ngcontent-ng-c3807070604="" aria-hidden="true">
                  ×
                </span>
              </button>
            </div>
            <div _ngcontent-ng-c3807070604="" className="modal-body">
              <div _ngcontent-ng-c3807070604="" className="col-md-12 roll">
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Fancy
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> 0</span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Matka
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> </span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Lottery
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> 0</span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Casino
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> 0</span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Binary
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> </span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Virtual
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> </span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Sportbook
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604="">0</span>
                  </div>
                </div>
                <div _ngcontent-ng-c3807070604="" className="view-rolling row">
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-2 col-3 col-form-label"
                  >
                    Bookmaker
                  </div>
                  <div
                    _ngcontent-ng-c3807070604=""
                    className="col-md-8 col-8 col-form-label"
                  >
                    <span _ngcontent-ng-c3807070604=""> 0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        _ngcontent-ng-c3807070604=""
        id="changePasswordModal"
        tabIndex={-1}
        aria-labelledby="changePasswordModalLabal"
        aria-hidden="true"
        className="modal fade"
      >
        <div _ngcontent-ng-c3807070604="" className="modal-dialog">
          <div _ngcontent-ng-c3807070604="" className="modal-content">
            <div
              _ngcontent-ng-c3807070604=""
              className="modal-header account-detail-head"
            >
              <h5 _ngcontent-ng-c3807070604="" className="modal-title">
                Change Password
              </h5>
              <button
                _ngcontent-ng-c3807070604=""
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                className="close"
              >
                <span _ngcontent-ng-c3807070604="" aria-hidden="true">
                  ×
                </span>
              </button>
            </div>
            <div
              _ngcontent-ng-c3807070604=""
              noValidate=""
              className="ng-untouched ng-pristine ng-invalid"
            >
              <div _ngcontent-ng-c3807070604="" className="modal-body">
                <div _ngcontent-ng-c3807070604="" className="row">
                  <div _ngcontent-ng-c3807070604="" className="col-md-6">
                    <div _ngcontent-ng-c3807070604="" className="form-group">
                      <label
                        _ngcontent-ng-c3807070604=""
                        htmlFor="oldPassword3"
                      >
                        Old Password{" "}
                        <span
                          _ngcontent-ng-c3807070604=""
                          className="asterisk_input"
                        />
                      </label>
                      <div
                        _ngcontent-ng-c3807070604=""
                        className="d-flex align-items-center position-relative"
                      >
                        <input
                          _ngcontent-ng-c3807070604=""
                          formcontrolname="MasterPassword"
                          id="oldPassword3"
                          name="oldPassword3"
                          required=""
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                          className="form-control ng-untouched ng-pristine ng-invalid"
                          type={
                            showOldPassword ? "text" : "password"
                           }
                        />
                        <div
                          _ngcontent-ng-c3807070604=""
                          className="input-group-append"
                        >
                          <button
                            onClick={() => setShowOldPassword(!showOldPassword)}
                            _ngcontent-ng-c3807070604=""
                            type="button"
                            className="btn btn-outline-secondary"
                            style={{ border: "none", zIndex: 999 }}
                          >
                            <i
                              _ngcontent-ng-c3807070604=""
                              className="fa fa-eye-slash"
                            />
                          </button>
                        </div>
                      </div>
                      {/**/}
                    </div>
                  </div>
                  <div _ngcontent-ng-c3807070604="" className="col-md-6">
                    <div _ngcontent-ng-c3807070604="" className="form-group">
                      <label _ngcontent-ng-c3807070604="" htmlFor="newPassword">
                        New Password{" "}
                        <span
                          _ngcontent-ng-c3807070604=""
                          className="asterisk_input"
                        />
                      </label>
                      <div
                        _ngcontent-ng-c3807070604=""
                        className="d-flex align-items-center position-relative"
                      >
                        <input
                          value={password}
                          onChange={(e) => setNewPassword(e.target.value)}
                          _ngcontent-ng-c3807070604=""
                          id="newPassword"
                          formcontrolname="password"
                          name="password"
                          required=""
                          autoComplete="off"
                          maxLength={20}
                          className=" form-control ng-untouched ng-pristine ng-invalid"
                          type={showPassword ? "text" : "password"}
                        />
                        <div
                          _ngcontent-ng-c3807070604=""
                          className="input-group-append"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <button
                            _ngcontent-ng-c3807070604=""
                            type="button"
                            className="btn btn-outline-secondary"
                            style={{ border: "none", zIndex: 999 }}
                          >
                            <i
                              _ngcontent-ng-c3807070604=""
                              className="fa fa-eye-slash"
                            />
                          </button>
                        </div>
                      </div>
                      {/**/}
                    </div>
                  </div>
                  <div _ngcontent-ng-c3807070604="" className="col-md-6">
                    <div _ngcontent-ng-c3807070604="" className="form-group">
                      <label
                        _ngcontent-ng-c3807070604=""
                        htmlFor="confirmPassword"
                      >
                        Confirm Password{" "}
                        <span
                          _ngcontent-ng-c3807070604=""
                          className="asterisk_input"
                        />
                      </label>
                      <div
                        _ngcontent-ng-c3807070604=""
                        className="d-flex align-items-center position-relative"
                      >
                        <input
                          _ngcontent-ng-c3807070604=""
                          id="confirmPassword"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          formcontrolname="confirmPassword"
                          maxLength={20}
                          name="confirmpassword"
                          required=""
                          className="form-control ng-untouched ng-pristine ng-invalid"
                          type={showConfirmPassword ? "text" : "password"}
                        />
                        <div
                          _ngcontent-ng-c3807070604=""
                          className="input-group-append"
                        >
                          <button
                            onClick={
                              () => setShowConfirmPassword(!showConfirmPassword)
                            }
                            _ngcontent-ng-c3807070604=""
                            type="button"
                            className="btn btn-outline-secondary"
                            style={{ border: "none", zIndex: 999 }}
                          >
                            <i
                              _ngcontent-ng-c3807070604=""
                              className="fa fa-eye-slash"
                            />
                          </button>
                        </div>
                      </div>
                      {/**/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c3807070604="" className="modal-footer">
              <button
                _ngcontent-ng-c3807070604=""
                className="btn btn-primary"
                onClick={handleChangePassword}
                disabled=""
              >
                Confirm
              </button>
              <button
                _ngcontent-ng-c3807070604=""
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                className="btn btn-secondary"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-my-profile>
  );
}
